import { render, staticRenderFns } from "./servicePersonnel.vue?vue&type=template&id=3cec4c5e&scoped=true&"
import script from "./servicePersonnel.vue?vue&type=script&lang=js&"
export * from "./servicePersonnel.vue?vue&type=script&lang=js&"
import style0 from "./servicePersonnel.vue?vue&type=style&index=0&id=3cec4c5e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cec4c5e",
  null
  
)

export default component.exports